/* UVINNECO — Aqua Clara tema · vanilla JS
   scroll-reveal, mobilni meni, FAQ, nativni Shopify cart drawer (AJAX). */
(function () {
  'use strict';

  /* ---------- Scroll reveal (fade + rise), spoštuje reduced-motion ---------- */
  function initReveal() {
    var els = document.querySelectorAll('.reveal');
    if (!els.length) return;
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---------- Glava: mobilni meni in preklopnik jezikov ----------
     Enako kot na potrjenih straneh: burger preklopi razred .open na glavi,
     meni se odpre iz nje same (ločenega predala ni). */
  function initHeader() {
    var nav = document.querySelector('[data-uvxnav]');
    var burger = document.querySelector('[data-uvxnav-burger]');
    if (nav && burger) {
      burger.addEventListener('click', function (e) {
        e.stopPropagation();
        var open = nav.classList.toggle('open');
        burger.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
      nav.querySelectorAll('.uvxnav-menu a').forEach(function (a) {
        a.addEventListener('click', function () { nav.classList.remove('open'); });
      });
      document.addEventListener('click', function (e) {
        if (!nav.contains(e.target)) nav.classList.remove('open');
      });
    }
    document.querySelectorAll('[data-uvx-lang]').forEach(function (w) {
      var btn = w.querySelector('[data-uvx-lang-btn]');
      if (!btn) return;
      btn.addEventListener('click', function (e) {
        e.stopPropagation();
        var wasOpen = w.hasAttribute('data-open');
        document.querySelectorAll('[data-uvx-lang][data-open]').forEach(function (x) { x.removeAttribute('data-open'); });
        if (!wasOpen) { w.setAttribute('data-open', ''); btn.setAttribute('aria-expanded', 'true'); }
        else { btn.setAttribute('aria-expanded', 'false'); }
      });
      w.querySelectorAll('[data-lang]').forEach(function (b) {
        b.addEventListener('click', function () {
          var url = b.getAttribute('data-url');
          if (!url) return;
          // Ohrani stran, na kateri je obiskovalec: root_url je le domača stran
          // jezika, zato predpono zamenjamo, poti pa ne izgubimo.
          var pre = url.replace(/\/$/, '');                 // '' za privzeti jezik, sicer '/de'
          var pot = window.location.pathname.replace(/^\/(sl|en|de|it|fr|pl|hr|es)(?=\/|$)/, '');
          if (!pot) pot = '/';
          window.location.href = pre + pot + window.location.search + window.location.hash;
        });
      });
      document.addEventListener('click', function (e) {
        if (!w.contains(e.target)) { w.removeAttribute('data-open'); btn.setAttribute('aria-expanded', 'false'); }
      });
    });
  }

  /* ---------- Mobilni meni (stara glava, ohranjeno za druge predloge) ---------- */
  function initMobileNav() {
    var openBtn = document.querySelector('[data-menu-toggle]');
    var nav = document.querySelector('[data-mobile-nav]');
    if (!openBtn || !nav) return;
    var closeEls = nav.querySelectorAll('[data-menu-close], a');
    function open() { nav.hidden = false; requestAnimationFrame(function () { nav.classList.add('on'); }); openBtn.setAttribute('aria-expanded', 'true'); document.body.classList.add('no-scroll'); }
    function close() { nav.classList.remove('on'); openBtn.setAttribute('aria-expanded', 'false'); document.body.classList.remove('no-scroll'); setTimeout(function () { nav.hidden = true; }, 300); }
    openBtn.addEventListener('click', open);
    nav.addEventListener('click', function (e) { if (e.target === nav) close(); });
    closeEls.forEach(function (el) { el.addEventListener('click', function (e) { if (el.hasAttribute('data-menu-close')) e.preventDefault(); close(); }); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && nav.classList.contains('on')) close(); });
  }

  /* ---------- FAQ akordeon ---------- */
  function initFaq() {
    document.querySelectorAll('[data-faq] > button, .faqq > button, .qa button').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var item = btn.parentElement;
        var ans = item.querySelector('.faqq-ans, .ans');
        var open = item.classList.toggle('open');
        if (open) { item.setAttribute('data-open', ''); } else { item.removeAttribute('data-open'); }
        if (ans) ans.style.maxHeight = open ? ans.scrollHeight + 'px' : '0px';
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });
  }

  /* ---------- Filtriranje FAQ: kategorija + iskanje + "prikaži vsa" ---------- */
  function initFaqFilter() {
    var items = document.querySelectorAll('[data-faq]');
    if (!items.length) return;
    var pills = document.querySelectorAll('[data-faq-cat]');
    var search = document.querySelector('[data-faq-search]');
    var emptyMsg = document.querySelector('[data-faq-empty]');
    var moreBtn = document.querySelector('[data-faq-more]');
    var moreLabel = document.querySelector('[data-faq-more-label]');
    var list = document.querySelector('[data-faq-limit]');
    var LIMIT = list ? parseInt(list.getAttribute('data-faq-limit'), 10) || 6 : 6;
    var activeCat = 'all';
    var showAll = false;

    function apply() {
      var term = (search && search.value ? search.value : '').toLowerCase().replace(/\s+/g, ' ').trim();
      var filtering = activeCat !== 'all' || term !== '';
      var matches = 0;
      items.forEach(function (item) {
        var okCat = activeCat === 'all' || item.getAttribute('data-cat') === activeCat;
        var okTxt = term === '' || item.textContent.toLowerCase().indexOf(term) !== -1;
        if (!(okCat && okTxt)) { item.style.display = 'none'; return; }
        matches++;
        item.style.display = (!filtering && !showAll && matches > LIMIT) ? 'none' : '';
      });
      if (emptyMsg) emptyMsg.classList.toggle('show', matches === 0);
      if (moreBtn) {
        if (!filtering && matches > LIMIT) {
          moreBtn.style.display = '';
          moreBtn.setAttribute('aria-expanded', showAll ? 'true' : 'false');
          if (moreLabel) {
            var lst = document.querySelector('[data-faq-limit]');
            var vec = (lst && lst.getAttribute('data-label-more')) || 'Prikaži vsa vprašanja';
            var manj = (lst && lst.getAttribute('data-label-less')) || 'Prikaži manj';
            moreLabel.textContent = showAll ? manj : vec + ' (' + matches + ')';
          }
        } else {
          moreBtn.style.display = 'none';
        }
      }
    }

    pills.forEach(function (pill) {
      pill.addEventListener('click', function () {
        pills.forEach(function (p) { p.classList.toggle('on', p === pill); });
        activeCat = pill.getAttribute('data-faq-cat');
        apply();
      });
    });
    if (search) search.addEventListener('input', apply);
    if (moreBtn) {
      moreBtn.addEventListener('click', function () {
        showAll = !showAll;
        apply();
        if (!showAll) {
          var sec = document.querySelector('.faqsec');
          if (sec) sec.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
    }
    apply();
  }

  /* ---------- Izdelek: zavihka Opis / Specifikacije (preklop, oba lahko zaprta) ---------- */
  function initProductTabs() {
    var tabs = document.querySelectorAll('.opis-tab');
    if (!tabs.length) return;
    tabs.forEach(function (t) {
      /* Vsak zavihek preklaplja samo svoj panel — oba sta lahko odprta hkrati,
         da je besedilo vidno takoj, kot v večini trgovin. */
      t.addEventListener('click', function () {
        var panel = document.getElementById(t.getAttribute('aria-controls'));
        var open = !t.classList.contains('is-active');
        t.classList.toggle('is-active', open);
        t.setAttribute('aria-selected', open ? 'true' : 'false');
        t.setAttribute('aria-expanded', open ? 'true' : 'false');
        if (panel) { panel.hidden = !open; panel.classList.toggle('is-open', open); }
      });
    });
  }

  /* ---------- Izdelek: zavihki velikosti navojev (kompatibilnost) ---------- */
  function initThreadTabs() {
    var tabs = [].slice.call(document.querySelectorAll('.ksize-tab'));
    if (!tabs.length) return;
    function closeAll() {
      tabs.forEach(function (t) {
        t.setAttribute('aria-selected', 'false');
        var p = document.getElementById(t.getAttribute('aria-controls'));
        if (p) { p.classList.remove('is-active'); p.setAttribute('hidden', ''); }
      });
    }
    function select(tab) {
      tabs.forEach(function (t) {
        var on = t === tab;
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        var p = document.getElementById(t.getAttribute('aria-controls'));
        if (!p) return;
        p.classList.toggle('is-active', on);
        if (on) { p.removeAttribute('hidden'); } else { p.setAttribute('hidden', ''); }
      });
    }
    /* Gumb "Zapri" ustvari v vsakem panelu (če ga še ni) */
    tabs.forEach(function (t) {
      var p = document.getElementById(t.getAttribute('aria-controls'));
      if (p && !p.querySelector('.ksize-close')) {
        var b = document.createElement('button');
        b.type = 'button'; b.className = 'ksize-close'; b.textContent = 'Zapri ✕';
        b.addEventListener('click', function () { closeAll(); });
        p.appendChild(b);
      }
    });
    tabs.forEach(function (t, i) {
      /* Klik na že odprt zavihek ga zapre (toggle), sicer ga odpre */
      t.addEventListener('click', function () {
        if (t.getAttribute('aria-selected') === 'true') { closeAll(); }
        else { select(t); }
      });
      t.addEventListener('keydown', function (e) {
        var d = e.key === 'ArrowRight' ? 1 : e.key === 'ArrowLeft' ? -1 : 0;
        if (!d) return;
        e.preventDefault();
        var n = tabs[(i + d + tabs.length) % tabs.length];
        n.focus(); select(n);
      });
    });
  }

  /* ---------- Domov: video "Kako deluje" — predvajaj ob kliku na gumb ---------- */
  function initHowVideo() {
    document.querySelectorAll('[data-hv]').forEach(function (f) {
      var v = f.querySelector('[data-hv-video]');
      var b = f.querySelector('[data-hv-play]');
      if (!v || !b) return;
      function play() { f.classList.add('is-playing'); try { v.currentTime = 0; } catch (e) {} v.play(); }
      b.addEventListener('click', play);
      // Naročnikova želja: posnetek naj se ustavi pri 19,5 s (zadnji del je odvečen).
      var konec = parseFloat(f.getAttribute('data-hv-stop') || '19.5');
      v.addEventListener('timeupdate', function () {
        if (konec > 0 && v.currentTime >= konec && !v.paused) { v.pause(); }
      });
      v.addEventListener('play', function () { f.classList.add('is-playing'); });
      v.addEventListener('pause', function () { if (v.currentTime > 0) f.classList.add('is-playing'); });
    });
  }

  /* ---------- Video: lasten gumb za premor/predvajanje ---------- */
  function initVideoStage() {
    document.querySelectorAll('[data-video-stage]').forEach(function (stage) {
      var vid = stage.querySelector('video');
      var btn = stage.querySelector('[data-video-ctrl]');
      if (!vid || !btn) return;
      btn.addEventListener('click', function () {
        if (vid.paused) { vid.play(); stage.classList.remove('is-paused'); }
        else { vid.pause(); stage.classList.add('is-paused'); }
      });
    });
  }

  /* ---------- Časovnica "O nas" in Vennov diagram: animacija ob prikazu ---------- */
  function initOnView(selector, cls) {
    var els = document.querySelectorAll(selector);
    if (!els.length) return;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add(cls); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add(cls); io.unobserve(e.target); }
      });
    }, { threshold: 0.2, rootMargin: '0px 0px -60px 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---------- AI asistentka UVI (izključno v brskalniku, brez zunanjih klicev) ---------- */
  function initAssistant() {
    var box = document.querySelector('[data-aia-body]');
    var form = document.querySelector('[data-aia-form]');
    var input = document.querySelector('[data-aia-input]');
    var sugg = document.querySelector('[data-aia-sugg]');
    var data = document.querySelector('[data-aia-kb]');
    if (!box || !form || !input || !data) return;

    var cfg;
    try { cfg = JSON.parse(data.textContent); } catch (e) { return; }
    var KB = cfg.kb || [];
    var avatar = box.getAttribute('data-aia-avatar') || '';

    function norm(s) {
      return (s || '').toLowerCase()
        .replace(/[čć]/g, 'c').replace(/š/g, 's').replace(/ž/g, 'z').replace(/đ/g, 'd')
        .replace(/[^a-z0-9 ]/g, ' ').replace(/\s+/g, ' ').trim();
    }
    function stem(w) { var s = w.replace(/[aeiou]*j?[aeiou]*$/, ''); return s.length >= 3 ? s : w; }

    function answer(q) {
      var t = norm(q);
      if (!t) return cfg.fallback;
      var words = t.split(' ').filter(function (w) { return w.length > 2; }).map(stem);
      var best = null, bestScore = 0;
      KB.forEach(function (entry) {
        var keys = norm(entry.k).split(' ').map(stem);
        var score = 0;
        words.forEach(function (a) {
          keys.forEach(function (b) {
            if (a === b) score += 2;
            else if (a.length >= 4 && b.length >= 4 && (a.indexOf(b) === 0 || b.indexOf(a) === 0)) score += 1;
          });
        });
        if (score > bestScore) { bestScore = score; best = entry; }
      });
      return (best && bestScore >= 2) ? best.a : cfg.fallback;
    }

    function down() { box.scrollTop = box.scrollHeight; }

    function addMsg(text, who) {
      var wrap = document.createElement('div');
      wrap.className = 'aia-msg aia-msg--' + who;
      if (who === 'bot') {
        wrap.innerHTML = '<span class="aia-ic"><img src="' + avatar + '" alt=""></span><div class="b">' + text + '</div>';
      } else {
        wrap.innerHTML = '<div class="b"></div>';
        wrap.querySelector('.b').textContent = text;
      }
      box.appendChild(wrap); down();
      return wrap;
    }

    function typing() {
      var wrap = document.createElement('div');
      wrap.className = 'aia-msg aia-msg--bot aia-typing';
      wrap.innerHTML = '<span class="aia-ic"><img src="' + avatar + '" alt=""></span><div class="b"><i></i><i></i><i></i></div>';
      box.appendChild(wrap); down();
      return wrap;
    }

    function ask(q) {
      addMsg(q, 'user');
      var t = typing();
      setTimeout(function () { t.remove(); addMsg(answer(q), 'bot'); }, 420 + Math.min(900, q.length * 14));
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var q = input.value.trim();
      if (!q) return;
      input.value = '';
      ask(q);
    });
    if (sugg) {
      sugg.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-aia-q]');
        if (btn) ask(btn.getAttribute('data-aia-q'));
      });
    }
    addMsg(cfg.greeting, 'bot');
  }

  /* ---------- Košarica (nativni Shopify AJAX) ---------- */
  var Cart = {
    drawer: null, overlay: null,
    open: function () { if (!this.drawer) return; this.overlay.classList.add('on'); this.drawer.classList.add('on'); document.body.classList.add('no-scroll'); },
    close: function () { if (!this.drawer) return; this.overlay.classList.remove('on'); this.drawer.classList.remove('on'); document.body.classList.remove('no-scroll'); },
    toast: function (msg) {
      var t = document.querySelector('[data-toast]');
      if (!t) return;
      t.textContent = msg; t.classList.add('on');
      clearTimeout(this._tt); this._tt = setTimeout(function () { t.classList.remove('on'); }, 2200);
    },
    fmt: function (cents) {
      try { return (cents / 100).toLocaleString('sl-SI', { style: 'currency', currency: window.Shopify && Shopify.currency ? Shopify.currency.active : 'EUR' }); }
      catch (e) { return (cents / 100).toFixed(2) + ' €'; }
    },
    refresh: function () {
      var self = this;
      return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) { self.render(cart); return cart; });
    },
    render: function (cart) {
      document.querySelectorAll('[data-cart-count]').forEach(function (el) {
        el.textContent = cart.item_count;
        if (cart.item_count > 0) el.removeAttribute('hidden'); else el.setAttribute('hidden', '');
      });
      var body = this.drawer && this.drawer.querySelector('[data-cart-body]');
      var footTotal = this.drawer && this.drawer.querySelector('[data-cart-total]');
      if (!body) return;
      if (!cart.items.length) {
        body.innerHTML = '<p class="cart-empty">Vaša košarica je prazna.</p>';
        if (footTotal) footTotal.textContent = this.fmt(0);
        var foot = this.drawer.querySelector('[data-cart-foot]');
        if (foot) foot.style.display = 'none';
        return;
      }
      var self = this;
      var html = cart.items.map(function (it) {
        var img = it.image ? it.image.replace(/(\.[a-z]+)(\?|$)/i, '_120x$1$2') : '';
        return '<div class="citem" data-key="' + it.key + '">' +
          '<div class="thumb">' + (img ? '<img src="' + img + '" alt="" width="54" height="54" style="width:54px;height:54px;object-fit:cover;border-radius:10px">' : '') + '</div>' +
          '<div><h4>' + it.product_title + '</h4>' +
          (it.variant_title && it.variant_title !== 'Default Title' ? '<p>' + it.variant_title + '</p>' : '') +
          '<div class="mini"><button type="button" data-dec aria-label="Manj">−</button><span>' + it.quantity + '</span><button type="button" data-inc aria-label="Več">+</button></div>' +
          '<button type="button" class="rm" data-remove>Odstrani</button></div>' +
          '<div class="lp">' + self.fmt(it.final_line_price) + '</div>' +
          '</div>';
      }).join('');
      body.innerHTML = html;
      if (footTotal) footTotal.textContent = this.fmt(cart.total_price);
      var foot = this.drawer.querySelector('[data-cart-foot]');
      if (foot) foot.style.display = '';
    },
    change: function (key, qty) {
      var self = this;
      return fetch('/cart/change.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty })
      }).then(function (r) { return r.json(); }).then(function (cart) { self.render(cart); return cart; });
    },
    add: function (id, qty) {
      var self = this;
      return fetch('/cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: id, quantity: qty || 1 }] })
      }).then(function (r) {
        if (!r.ok) return r.json().then(function (e) { throw e; });
        return r.json();
      }).then(function () {
        return self.refresh().then(function () { self.open(); self.toast('Dodano v košarico'); });
      }).catch(function (e) { self.toast((e && e.description) || 'Napaka pri dodajanju'); });
    },
    init: function () {
      this.drawer = document.querySelector('[data-cart-drawer]');
      this.overlay = document.querySelector('[data-cart-overlay]');
      var self = this;

      document.querySelectorAll('[data-cart-toggle]').forEach(function (el) {
        el.addEventListener('click', function (e) { e.preventDefault(); self.refresh().then(function () { self.open(); }); });
      });
      if (this.overlay) this.overlay.addEventListener('click', function () { self.close(); });
      document.querySelectorAll('[data-cart-close]').forEach(function (el) { el.addEventListener('click', function () { self.close(); }); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') self.close(); });

      /* delegacija za +/- / odstrani v drawerju */
      if (this.drawer) {
        this.drawer.addEventListener('click', function (e) {
          var row = e.target.closest('.citem'); if (!row) return;
          var key = row.getAttribute('data-key');
          var span = row.querySelector('.mini span');
          var q = parseInt(span ? span.textContent : '1', 10);
          if (e.target.closest('[data-inc]')) self.change(key, q + 1);
          else if (e.target.closest('[data-dec]')) self.change(key, Math.max(0, q - 1));
          else if (e.target.closest('[data-remove]')) self.change(key, 0);
        });
      }

      /* vse product-add forme (PDP, hitri nakup) prek AJAX */
      document.querySelectorAll('form[action*="/cart/add"]').forEach(function (form) {
        form.addEventListener('submit', function (e) {
          /* "Kupi zdaj" (name=checkout) → nativna oddaja naravnost na blagajno */
          var submitter = e.submitter || (document.activeElement && document.activeElement.form === form ? document.activeElement : null);
          if (submitter && submitter.name === 'checkout') { return; }
          e.preventDefault();
          var idField = form.querySelector('[name="id"]');
          var qtyField = form.querySelector('[name="quantity"]');
          if (!idField) { form.submit(); return; }
          self.add(idField.value, qtyField ? parseInt(qtyField.value, 10) : 1);
        });
      });
    }
  };

  /* ---------- Količinski gumbi (PDP) ---------- */
  function initQty() {
    document.querySelectorAll('[data-qty]').forEach(function (wrap) {
      var input = wrap.querySelector('input');
      wrap.querySelector('[data-qty-dec]').addEventListener('click', function () { input.value = Math.max(1, parseInt(input.value, 10) - 1); });
      wrap.querySelector('[data-qty-inc]').addEventListener('click', function () { input.value = parseInt(input.value, 10) + 1; });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initReveal(); initHeader(); initMobileNav(); initFaq(); initFaqFilter(); initQty(); Cart.init();
    initVideoStage(); initAssistant(); initProductTabs(); initThreadTabs(); initHowVideo();
    initOnView('[data-story]', 'is-run'); initOnView('[data-venn]', 'venn-draw');
  });
  window.UVCart = Cart;
})();

/* Glava: ko odrsamo z vrha, dobi telo razred .nav-scrolled (polna glava + senca). */
(function(){
  var b = document.body, prag = 8, zadnje = null;
  function osvezi(){
    var je = window.scrollY > prag;
    if (je !== zadnje) { b.classList.toggle('nav-scrolled', je); zadnje = je; }
  }
  function visina(){
    var n = document.querySelector('.uvxnav');
    if (n) document.documentElement.style.setProperty('--navh', Math.round(n.getBoundingClientRect().height) + 'px');
  }
  window.addEventListener('scroll', osvezi, { passive: true });
  document.addEventListener('scroll', osvezi, { passive: true });
  window.addEventListener('resize', visina);
  visina(); osvezi();
})();
